import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ExamtypeService } from '../../providers/examtype/examtype.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-examtype-modal',
  templateUrl: './examtype-modal.component.html',
  styleUrls: ['./examtype-modal.component.scss']
})
export class ExamTypeModalComponent implements OnInit {
  examTypeForm: FormGroup;

  local_data: any;
  id: number;
  description: string;
  name: string;

  constructor(public fb: FormBuilder, public dialogRef: MatDialogRef<ExamTypeModalComponent>,
    private examTypeService: ExamtypeService, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.examTypeForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()

    });

    this.examTypeForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]]

    })
  }

  editForm() {
    this.examTypeForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()

    });

    this.examTypeForm = this.fb.group({
      name: [this.data.name, [Validators.required]],
      description: [this.data.description, [Validators.required]]

    })
  }

  addExamType() {

    if (!this.id) {
      console.log(this.examTypeForm.value);
      this.examTypeService.addExamType(this.examTypeForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {

      console.log(this.examTypeForm.value);
      this.examTypeService.editExamType(this.id, this.examTypeForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }


  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
